export default __webpack_public_path__ + "static/media/SeaLife_12.a36d72cc.png";